var _path, _path2;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgLinks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9665 6.0335C6.89893 4.96594 5.16807 4.96594 4.1005 6.0335L2.16751 7.9665C1.09994 9.03406 1.09994 10.7649 2.16751 11.8325C3.23507 12.9001 4.96594 12.9001 6.0335 11.8325L6.51675 11.3492H8.44975L7 12.799C5.39865 14.4003 2.80236 14.4003 1.20101 12.799C-0.400337 11.1976 -0.400337 8.60135 1.20101 7L3.13401 5.067C4.73535 3.46566 7.33165 3.46566 8.933 5.067C9.27189 5.40589 9.53906 5.78934 9.73451 6.19849L8.6744 7.2586C8.55455 6.80981 8.31858 6.38558 7.9665 6.0335Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0335 7.9665C7.10107 9.03406 8.83193 9.03406 9.89949 7.9665L11.8325 6.0335C12.9001 4.96594 12.9001 3.23507 11.8325 2.16751C10.7649 1.09994 9.03406 1.09994 7.9665 2.16751L7.48325 2.65076L5.55025 2.65076L7 1.20101C8.60135 -0.400337 11.1976 -0.400337 12.799 1.20101C14.4003 2.80236 14.4003 5.39865 12.799 7L10.866 8.933C9.26465 10.5343 6.66835 10.5343 5.067 8.933C4.72811 8.59411 4.46094 8.21066 4.26549 7.80151L5.3256 6.7414C5.44545 7.19019 5.68142 7.61441 6.0335 7.9665Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinks);
export default __webpack_public_path__ + "static/media/links.4e30234266c3904dc33c2c5e882c734a.svg";
export { ForwardRef as ReactComponent };